import { IGeoLocation } from "./types";
import { useEffect, useState } from "react";
import { hasCookiePolicyRestriction } from "./utils";

export default function useGeoLocation() {
  const [geoLocation, setGeoLocation] = useState<IGeoLocation>();
  const [error, setError] = useState<unknown>();

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    async function getGeoLocationAsync() {
      try {
        const response = await fetch(
          "https://get.geojs.io/v1/ip/country.json",
          {
            method: "GET",
          },
        );
        const res = await response.json();
        setGeoLocation(res);
        setError(null);
      } catch (err) {
        if (!err) {
          setError(err);
        }
        console.error(err);
        timeoutId = setTimeout(getGeoLocationAsync, 3000);
      }
    }

    getGeoLocationAsync();

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  if (geoLocation) {
    geoLocation.hasCookiePolicyRestriction =
      hasCookiePolicyRestriction(geoLocation);
  }

  return { data: geoLocation, error };
}
